import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 是否显示tabbar
export const SHOW_TAB_BAR = 'SHOW_TAB_BAR'

export default new Vuex.Store({
    state: {
        showTabbar: false,
        public_code: '',
        hasLucky: false
    },
    mutations: {
        [SHOW_TAB_BAR](state, payload) {
            state.showTabbar = payload
        },
        // 设置扫码带入的命名
        setPublicCode(state, val) {
            state.public_code = val
        },
        clearPublicCode(state) {
            state.public_code = ''
        },
        setActive(state, val) {
            state.hasLucky = val
        }
    },
    getters: {
        getPublicCode(state) {
            return state.public_code
        },
        getHasLucky(state) {
            return state.hasLucky
        }
    },
    actions: {
    }
})
